import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { 
    useMediaQuery, 
    useTheme,
    Container, 
    Box, 
} from "@mui/material";
import axios from "axios";
import { withPather } from "react-pather";
import Loader from "../Loader";
import { WarningMessage } from "../general";
import { PROJECT_NAME } from "../../config";
import LinkDisplay from "../account/view/LinkDisplay";


const Check = ({ pather }) => {

    const theme = useTheme();
    const matchesDownSm = useMediaQuery(theme.breakpoints.down('sm'));

    const { code } = useParams();

    const [conversion, setConversion] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isRevealable, setIsRevealable] = useState(false);

    useEffect(() => {
        setLoading(true);
        axios.get(
            pather.reverse(pather.back.Conversion.check, { code }),   
        )
        .then(response => {
            const conversion = response?.data?.conversion;
            
            if (conversion?.revealable === true) setIsRevealable(true);
            
            if (conversion?.code) setConversion(conversion);
            else throw new Error('Data is not provided!');
        })
        .catch(error => {
            console.log(error);
            const status = error?.data?.status;
            if(status) setError(status);
            else {
                if (error?.response?.status === 404) setError('Resource is not found!');
                else setError('Something went wrong!');
            }
        })
        .finally(() => {
            setLoading(false);    
        });
    }, []);

    return (
        <Container sx={{
            minHeight: '550px', 
            display: 'flex',
            alignItems: 'center', 
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 1,
        }}>
            {
                loading ? 
                <Loader /> :
                <>
                    {
                        error ? 
                        <Box sx={{display: 'flex', width: '100%', justifyContent: 'center', alignItems: 'center'}}>
                            <h1>{error} &#128546;</h1>
                        </Box> :
                        <>
                            <Box>
                                <h1>Check Your {PROJECT_NAME} Link</h1>
                            </Box>
                            <Box sx={{
                                my: 2, 
                                fontSize: { md: 16, xs: 12 }, 
                                width: '100%',
                                display: 'flex', 
                                flexDirection: 'column',
                            }}>
                                <Box sx={{
                                    width: { xs: '90%', sm: '93%', md: '97%' },
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}>
                                    <Box>
                                        <LinkDisplay 
                                            link={`${window.location.origin}${pather.reverse(pather.front.main, { code: conversion.code })}`}
                                            label='Shortened link: '
                                        />
                                    </Box>
                                    {
                                        isRevealable ?
                                        <Box>
                                            <LinkDisplay 
                                                link={conversion.source}
                                                label='Source link: '
                                            />
                                        </Box> :
                                        <Box>
                                            <WarningMessage 
                                                message={
                                                    <>
                                                        Information about this link is hidden. If you’re unsure where it may lead or suspect abuse, please avoid clicking it and report the link to us at <i>contact@shodl.io</i>.
                                                    </>
                                                }
                                            />
                                        </Box>
                                    }
                                </Box>
                                {
                                    isRevealable &&
                                    <Box sx={{
                                        display: 'flex', 
                                        flexDirection: matchesDownSm ? 'column' : 'row', 
                                        alignItems: !matchesDownSm && 'center', 
                                        gap: 1,
                                    }}>
                                        <Box sx={{fontSize: '16px'}}>
                                            <h3>Creation date:</h3>
                                        </Box>
                                        <Box sx={{fontSize: '17px'}}>
                                            {conversion.createdAt}
                                        </Box>
                                    </Box>
                                }
                            </Box>
                        </>
                    }
                </>
            }
        </Container>
    );
}

export default withPather()(Check);